import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const JacanaPage = () => <LocationTemplate suburbName="Jacana" suburbSlug="jacana" />;

export default JacanaPage;
